<template>
  <div class="h-full">
    <div>
      <div
        class="w-full h-48 bg-gray-900 flex flex-wrap content-center justify-center text-white"
      >
        <icon
          name="WaldigLogo"
          size="8rem"
          :settings="{ strokeWidth: 0.8, circle: true }"
        />
      </div>
      <div
        class="flex items-center justify-center max-w-xs md:max-w-md mx-auto"
      >
        <div class="pt-8 w-full">
          <h2 class="text-center">{{ $t("register.register") }}</h2>
          <register-form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const RegisterForm = require("@/modules/login/components/RegisterForm").default;

export default {
  name: "RegisterSite",
  mixins: [],
  data: () => ({
    status: {},
  }),
  computed: {},
  methods: {},
  async created() {},
  components: {
    RegisterForm,
  },
};
</script>
